import queryLogout from "@/services/logout"

const useFetchLogout = () => {
  const authStore = useAuthStore()
  const websiteSettingStore = useWebsiteSettingStore()

  const { handler } = queryLogout
  const fetchLogout = async () => {
    try {
      await handler()
      authStore.resetPlayerInfo()
      websiteSettingStore.resetIsOneClickBet()

      websiteSettingStore.certificationLocalStorage.update({
        resetPassword: false,
        termsVersion: []
      })

      authStore.resetCertification()

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  return { fetchLogout }
}

export default useFetchLogout
